import classNames from 'classnames';
import {
  Button,
  ErrorMessage,
  FlexContainer,
  Spinner,
  TitledBlock,
} from 'components';
import { observer } from 'mobx-react-lite';
import { usePublicAccount } from 'state';
import { BooleanInput, MenuItem } from '../../components';
import { useUserStateHelpers } from '../../hooks';
import styles from './EditProfileAccount.module.scss';

/**
 * EditProfileAccount
 *
 * @return {JSX.Element}
 */
const EditProfileAccount = ({ className }) => {
  const publicAccountDoc = usePublicAccount();
  const { handleNotification, handleSubmit, data, isDirty, isLoading, error } =
    useUserStateHelpers(publicAccountDoc);

  return (
    <form
      className={classNames(
        styles.EditProfileAccount,
        className,
        `${EditProfileAccount.displayName}`
      )}
      onSubmit={handleSubmit}
    >
      <TitledBlock title="Notifications">
        <MenuItem>
          <BooleanInput
            title="Search"
            description="When new viewing applications are received, or new properties in your search area."
            name="search"
            checked={data.noticePreferences?.search}
            onChange={handleNotification}
            disabled={isLoading}
          />
        </MenuItem>
        <MenuItem>
          <BooleanInput
            title="Messaging"
            description="Messages from people within your tenancy group."
            name="messaging"
            checked={data.noticePreferences?.messaging}
            onChange={handleNotification}
            disabled={isLoading}
          />
        </MenuItem>
        <MenuItem>
          <BooleanInput
            title="Payments"
            description="When payments have or have not been completed in the tenancy group."
            name="payments"
            checked={data.noticePreferences?.payments}
            onChange={handleNotification}
            disabled={isLoading}
          />
        </MenuItem>
        <MenuItem>
          <BooleanInput
            title="People"
            description="Tenants linking to a tenancy."
            name="people"
            checked={data.noticePreferences?.people}
            onChange={handleNotification}
            disabled={isLoading}
          />
        </MenuItem>
        <MenuItem>
          <BooleanInput
            title="Tenancy"
            description="Start/end of tenancy, payment due dates, deposit registration."
            name="tenancy"
            checked={data.noticePreferences?.tenancy}
            onChange={handleNotification}
            disabled={isLoading}
          />
        </MenuItem>
        {error ? <ErrorMessage small title={error} /> : null}
        {isDirty ? (
          <FlexContainer column gap>
            <FlexContainer />
            <Button flex success type="submit" disabled={isLoading}>
              {isLoading ? <Spinner /> : 'Save'}
            </Button>
          </FlexContainer>
        ) : null}
      </TitledBlock>
    </form>
  );
};

EditProfileAccount.displayName = 'EditProfileAccount';

export default observer(EditProfileAccount);
